// Define user roles array, convenient for batch generating routes
export const userRoles = ['visitor', 'exhibitor', 'organizer', 'contractors', 'designer']

// Grouped route configurations by module
// chunkName 用于 webpack 代码分割，相同 chunkName 的路由会打包到同一个 JS 文件中
export const routeConfigs = [
  // 邀请页
  { path: 'inviteToReachCustomer', component: 'inviteToReachCustomer.vue', chunkName: 'invite' },

  // 招标管理相关
  { path: 'bidding', component: 'bidding/index.vue', chunkName: 'bidding' },
  { path: 'bidding/release', component: 'bidding/release.vue', chunkName: 'bidding' },
  { path: 'bidding/detail', component: 'bidding/detail.vue', chunkName: 'bidding' },

  // 订单管理相关
  { path: 'order', component: 'order/order.vue', chunkName: 'order' },
  { path: 'order/detail', component: 'order/detail.vue', chunkName: 'order' },
  { path: 'order/incomeDetail', component: 'order/incomeDetail.vue', chunkName: 'order' },

  // 海报管理
  { path: 'poster/poster', component: 'poster.vue', chunkName: 'misc' },

  // 优惠券管理
  { path: 'coupon', component: 'coupon.vue', chunkName: 'misc' },

  // 我的收藏
  { path: 'keep', component: 'keep.vue', chunkName: 'misc' },

  // 关注的企业
  { path: 'companiesToWatch', component: 'companiesToWatch/index.vue', chunkName: 'misc' },

  // 我的钱包相关
  { path: 'account', component: 'account/account.vue', chunkName: 'account' },
  { path: 'account/vip', component: 'account/vip.vue', chunkName: 'account' },
  { path: 'account/recharge', component: 'account/recharge.vue', chunkName: 'account' },
  { path: 'account/withdraw', component: 'account/withdraw.vue', chunkName: 'account' },
  { path: 'account/withdrawDetail', component: 'account/withdrawDetail.vue', chunkName: 'account' },

  // 我的直播，仅参展商和主办方
  { path: 'myLive', component: 'myLive/index.vue', roles: ['organizer', 'exhibitor'], chunkName: 'live' },
  { path: 'myReplayList', component: 'myLive/myReplayList', roles: ['organizer', 'exhibitor'], chunkName: 'live' },
  { path: 'detail', component: 'myLive/detail.vue', roles: ['organizer', 'exhibitor'], chunkName: 'live' },

  // 我的展览
  { path: 'myExhibit/visitSignup', component: 'myExhibit/visitSignup.vue', chunkName: 'exhibit' },
  {
    path: 'myExhibit/buildSignup',
    component: 'myExhibit/buildSignup.vue',
    roles: ['organizer', 'exhibitor'],
    chunkName: 'exhibit',
  },
  {
    path: 'myExhibit/exhibitSignup',
    component: 'myExhibit/exhibitSignup.vue',
    roles: ['exhibitor'],
    chunkName: 'exhibit',
  },

  // 云头条
  {
    path: 'information',
    component: 'information/index.vue',
    roles: ['organizer', 'exhibitor', 'contractors', 'designer'],
    chunkName: 'information',
  },
  {
    path: 'information/detail',
    component: 'information/detail.vue',
    roles: ['organizer', 'exhibitor', 'contractors', 'designer'],
    chunkName: 'information',
  },
  {
    path: 'information/release',
    component: 'information/release.vue',
    roles: ['organizer', 'exhibitor', 'contractors', 'designer'],
    chunkName: 'information',
  },

  // 发票管理
  {
    path: 'invoice',
    component: 'invoice/invoice.vue',
    roles: ['organizer', 'exhibitor', 'contractors', 'designer'],
    chunkName: 'invoice',
  },
  {
    path: 'invoice/detail',
    component: 'invoice/detail.vue',
    roles: ['organizer', 'exhibitor', 'contractors', 'designer'],
    chunkName: 'invoice',
  },

  // 展厅管理，仅工程商和设计师
  { path: 'showroom', component: 'showroom/showroom.vue', roles: ['contractors', 'designer'], chunkName: 'showroom' },
  {
    path: 'showroom/buyList',
    component: 'showroom/buyList.vue',
    roles: ['contractors', 'designer'],
    chunkName: 'showroom',
  },
  {
    path: 'showroom/release',
    component: 'showroom/release.vue',
    roles: ['contractors', 'designer'],
    chunkName: 'showroom',
  },
  {
    path: 'showroom/detail',
    component: 'showroom/detail.vue',
    roles: ['contractors', 'designer'],
    chunkName: 'showroom',
  },

  // 定制管理，仅工程商和设计师
  {
    path: 'customize',
    component: 'customize/customize.vue',
    roles: ['contractors', 'designer'],
    chunkName: 'showroom',
  },

  // 云采购相关
  { path: 'procurement/cloud', component: 'procurement/cloud/index.vue', chunkName: 'procurement' },
  { path: 'procurement/cloud/detail', component: 'procurement/cloud/detail.vue', chunkName: 'procurement' },
  { path: 'procurement/cloud/release', component: 'procurement/cloud/release.vue', chunkName: 'procurement' },
  {
    path: 'procurement/customer',
    component: 'procurement/customer.vue',
    roles: ['exhibitor'],
    chunkName: 'procurement',
  },
  {
    path: 'procurement/cloud/opportunities',
    component: 'procurement/cloud/opportunities.vue',
    chunkName: 'procurement',
  },
  {
    path: 'procurement/cloud/opportunitiesDetail',
    component: 'procurement/cloud/opportunitiesDetail.vue',
    chunkName: 'procurement',
  },

  // 招商相关，排除访客和设计师
  {
    path: 'merchants',
    component: 'merchants/index.vue',
    roles: ['exhibitor', 'organizer', 'contractors'],
    chunkName: 'merchants',
  },
  {
    path: 'merchants/operation',
    component: 'merchants/operation.vue',
    roles: ['exhibitor', 'organizer', 'contractors'],
    chunkName: 'merchants',
  },
  {
    path: 'merchants/detail',
    component: 'merchants/detail.vue',
    roles: ['exhibitor', 'organizer', 'contractors'],
    chunkName: 'merchants',
  },

  // 我的采购
  { path: 'procurement/self', component: 'procurement/self/index.vue', chunkName: 'procurement' },
  { path: 'procurement/self/detail', component: 'procurement/self/detail.vue', chunkName: 'procurement' },

  // 名片相关
  { path: 'card', component: 'myCard/myCard.vue', chunkName: 'card' },
  { path: 'cardAddressBook', component: 'myCard/cardAddressBook.vue', chunkName: 'card' },

  // 名片编辑
  {
    path: 'myCard/editor/companyInfo',
    component: 'myCard/editor/MyCloudCompanyInfoEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'card-editor',
  },
  {
    path: 'myCard/editor/contactInfo',
    component: 'myCard/editor/MyCloudCompanyContactInfoEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'card-editor',
  },
  {
    path: 'myCard/editor/companyBrochure',
    component: 'myCard/editor/MyCloudCompanyBrochureEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'card-editor',
  },
  {
    path: 'myCard/editor/corporateVideo',
    component: 'myCard/editor/MyCloudCompanyCorporateVideoEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'card-editor',
  },
  {
    path: 'myCard/editor/albumGlory/:type',
    component: 'myCard/editor/MyCloudCompanyAlbumGloryEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'card-editor',
  },
  // 产品服务
  {
    path: 'product',
    component: 'product/index.vue',
    roles: ['exhibitor'],
    chunkName: 'product',
  },
  {
    path: 'product/release',
    component: 'product/release.vue',
    roles: ['exhibitor'],
    chunkName: 'product',
  },
  // 企业展览
  {
    path: 'myCard/editor/recommendedExhibitions',
    component: 'myCard/editor/RecommendedExhibitionsEditor.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'card-editor',
  },

  // 客户数据相关
  { path: 'data', component: 'myData/index.vue', chunkName: 'data' },
  { path: 'data/detail', component: 'myData/detail.vue', chunkName: 'data' },
  { path: 'data/userDetail', component: 'myData/userDetail.vue', chunkName: 'data' },
  {
    path: 'data/visitorDetail',
    component: 'myData/visitorDetail.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'data',
  },

  // 基本资料
  { path: 'basicInfo', component: 'basicInfo/index.vue', chunkName: 'basic' },
  { path: 'basicInfo/myInvite', component: 'basicInfo/myInvite.vue', chunkName: 'basic' },

  // 我的会议
  { path: 'myMeeting/join', component: 'myMeeting/join.vue', chunkName: 'meeting' },
  { path: 'myMeeting/sponsor', component: 'myMeeting/sponsor.vue', chunkName: 'meeting' },

  // 企业认证
  { path: 'enterpriseCertification', component: 'enterpriseCertification/index.vue', chunkName: 'basic' },

  // 消息与通知
  { path: 'notifications', component: 'notifications.vue', chunkName: 'notifications' },
  { path: 'sysmsgDetail', component: 'sysmsgDetail.vue', chunkName: 'notifications' },

  // 子账号管理
  { path: 'ram', component: 'ResourceAccessManagement/index.vue', chunkName: 'ram' },
  { path: 'ram/detail/:id', component: 'ResourceAccessManagement/RAMDetail.vue', chunkName: 'ram' },

  // 子账号管理-客户详情（排除访客角色）
  {
    path: 'customer/detail/:id',
    component: 'ResourceAccessManagement/CustomerDetail.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'ram',
  },

  // 企业云展系统
  {
    path: 'cces/cloud',
    component: 'CompanyCloudExpoSystems/cloud.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces',
  },

  // 企业漫游
  {
    path: 'cces/roaming',
    component: 'CompanyCloudExpoSystems/roaming.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces',
  },

  // 主办方的展览管理
  {
    path: 'exhibition',
    component: 'exhibition/index.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/detail',
    component: 'exhibition/detail.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/release',
    component: 'exhibition/release.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/boothList',
    component: 'exhibition/boothList.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/exhibitList',
    component: 'exhibition/exhibitList.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/labelList',
    component: 'exhibition/labelList.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/liveReplay',
    component: 'exhibition/liveReplay.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/photoList',
    component: 'exhibition/photoList.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/productList',
    component: 'exhibition/productList.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },
  {
    path: 'exhibition/visitList',
    component: 'exhibition/visitList.vue',
    roles: ['organizer'],
    chunkName: 'exhibition',
  },

  // 主办方的会议管理
  {
    path: 'meeting',
    component: 'meeting/index.vue',
    roles: ['organizer'],
    chunkName: 'meeting-org',
  },
  {
    path: 'meeting/detail',
    component: 'meeting/detail.vue',
    roles: ['organizer'],
    chunkName: 'meeting-org',
  },
  {
    path: 'meeting/release',
    component: 'meeting/release.vue',
    roles: ['organizer'],
    chunkName: 'meeting-org',
  },
  {
    path: 'meeting/liveReplay',
    component: 'meeting/liveReplay.vue',
    roles: ['organizer'],
    chunkName: 'meeting-org',
  },
  {
    path: 'meeting/sponsorList',
    component: 'meeting/sponsorList.vue',
    roles: ['organizer'],
    chunkName: 'meeting-org',
  },
  {
    path: 'meeting/visitList',
    component: 'meeting/visitList.vue',
    roles: ['organizer'],
    chunkName: 'meeting-org',
  },

  // 企业信息编辑相关
  {
    path: 'myCloudCompany/editor/companyInfo',
    component: 'CompanyCloudExpoSystems/MyCloudCompanyEditor/MyCloudCompanyInfoEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-editor',
  },
  {
    path: 'myCloudCompany/editor/contactInfo',
    component: 'CompanyCloudExpoSystems/MyCloudCompanyEditor/MyCloudCompanyContactInfoEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-editor',
  },
  {
    path: 'myCloudCompany/editor/cloudEnterprise',
    component: 'CompanyCloudExpoSystems/MyCloudCompanyEditor/MyCloudCompanyCloudEnterpriseEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-editor',
  },
  {
    path: 'myCloudCompany/editor/corporateVideo',
    component: 'CompanyCloudExpoSystems/MyCloudCompanyEditor/MyCloudCompanyCorporateVideoEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-editor',
  },
  {
    path: 'myCloudCompany/editor/albumGlory/:type',
    component: 'CompanyCloudExpoSystems/MyCloudCompanyEditor/MyCloudCompanyAlbumGloryEditorFrom.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-editor',
  },

  // 统计相关
  {
    path: 'cces/count',
    component: 'CompanyCloudExpoSystems/count/index.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-count',
  },
  {
    path: 'cces/count/detail',
    component: 'CompanyCloudExpoSystems/count/detail.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-count',
  },
  {
    path: 'cces/count/subAccount',
    component: 'CompanyCloudExpoSystems/count/subAccount.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-count',
  },

  // 客户库管理
  {
    path: 'cces/count/customerDatabase',
    component: 'dataMarketing/addressBook/index.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'marketing',
  },
  {
    path: 'cces/count/myCustomerDatabase',
    component: 'dataMarketing/addressBook/my.vue',
    chunkName: 'marketing',
  },
  {
    path: 'cces/count/subAccountDetail',
    component: 'CompanyCloudExpoSystems/count/subAccountDetail.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-count',
  },

  // 客户数据和管理
  {
    path: 'cces/count/customerData',
    component: 'CompanyCloudExpoSystems/count/customerData.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-count',
  },
  {
    path: 'cces/count/customerManage',
    component: 'CompanyCloudExpoSystems/count/customerManage.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-count',
  },
  {
    path: 'cces/count/staffManage',
    component: 'CompanyCloudExpoSystems/count/staffManage.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-count',
  },

  // 企业动态和云招聘
  {
    path: 'cces/dynamic',
    component: 'CompanyCloudExpoSystems/dynamic.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces',
  },
  {
    path: 'cces/recruit',
    component: 'CompanyCloudExpoSystems/recruit/index.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-recruit',
  },
  {
    path: 'cces/recruit/detail',
    component: 'CompanyCloudExpoSystems/recruit/detail.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-recruit',
  },
  {
    path: 'cces/recruit/release',
    component: 'CompanyCloudExpoSystems/recruit/release.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'cces-recruit',
  },

  // 云优惠相关（仅参展商和主办方）
  {
    path: 'cces/offers',
    component: 'CompanyCloudExpoSystems/offers/index.vue',
    roles: ['exhibitor', 'organizer'],
    chunkName: 'cces-offers',
  },
  {
    path: 'cces/offers/add',
    component: 'CompanyCloudExpoSystems/offers/add.vue',
    roles: ['exhibitor', 'organizer'],
    chunkName: 'cces-offers',
  },
  {
    path: 'cces/offers/detail/:id',
    component: 'CompanyCloudExpoSystems/offers/detail.vue',
    roles: ['exhibitor', 'organizer'],
    chunkName: 'cces-offers',
  },

  // 优惠券
  { path: 'myCoupons', component: 'myCoupons/index.vue', chunkName: 'coupons' },

  // 外呼呼叫相关
  { path: 'dataMarketing/aiCall', component: 'dataMarketing/aiCall/index.vue', chunkName: 'marketing-aicall' },
  {
    path: 'dataMarketing/aiCall/words',
    component: 'dataMarketing/aiCall/words/index.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'marketing-aicall',
  },
  {
    path: 'dataMarketing/aiCall/task',
    component: 'dataMarketing/aiCall/task/index.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'marketing-aicall',
  },
  {
    path: 'dataMarketing/aiCall/task/release',
    component: 'dataMarketing/aiCall/task/release.vue',
    chunkName: 'marketing-aicall',
  },
  {
    path: 'dataMarketing/aiCall/record',
    component: 'dataMarketing/aiCall/record/index.vue',
    roles: ['exhibitor', 'organizer', 'contractors', 'designer'],
    chunkName: 'marketing-aicall',
  },

  // 精准邀约相关
  {
    path: 'dataMarketing/preciseInvitation/:type',
    component: 'dataMarketing/preciseInvitation/index.vue',
    chunkName: 'marketing-invite',
  },
  {
    path: 'dataMarketing/preciseInvitation/template/:type',
    component: 'dataMarketing/preciseInvitation/template/index.vue',
    chunkName: 'marketing-invite',
  },
  {
    path: 'dataMarketing/preciseInvitation/link/:type',
    component: 'dataMarketing/preciseInvitation/link/index.vue',
    chunkName: 'marketing-invite',
  },
  {
    path: 'dataMarketing/linkDetail',
    component: 'dataMarketing/preciseInvitation/link/linkDetail.vue',
    chunkName: 'marketing-invite',
  },
  {
    path: 'dataMarketing/effect',
    component: 'dataMarketing/preciseInvitation/link/effect.vue',
    chunkName: 'marketing-invite',
  },
  {
    path: 'dataMarketing/preciseInvitation/record/details',
    component: 'dataMarketing/preciseInvitation/record/details.vue',
    chunkName: 'marketing-invite',
  },
  {
    path: 'dataMarketing/preciseInvitation/record/china',
    component: 'dataMarketing/preciseInvitation/record/china.vue',
    chunkName: 'marketing-invite',
  },
  {
    path: 'dataMarketing/preciseInvitation/record/international',
    component: 'dataMarketing/preciseInvitation/record/international.vue',
    chunkName: 'marketing-invite',
  },

  // 邀请相关
  { path: 'dataMarketing/invite', component: 'dataMarketing/invite/index.vue', chunkName: 'marketing' },
  {
    path: 'dataMarketing/invite/effect/detail',
    component: 'dataMarketing/invite/effect/detail.vue',
    chunkName: 'marketing',
  },
  {
    path: 'dataMarketing/invite/operation',
    component: 'dataMarketing/invite/OperationSmsTemplate.vue',
    chunkName: 'marketing',
  },
  {
    path: 'dataMarketing/invite/operation/email',
    component: 'dataMarketing/invite/OperationEmailTemplate.vue',
    chunkName: 'marketing',
  },
  {
    path: 'dataMarketing/invite/initiateInvitation',
    component: 'dataMarketing/invite/InitiateInvitation.vue',
    chunkName: 'marketing',
  },
  {
    path: 'dataMarketing/invite/initiateInvitation/email',
    component: 'dataMarketing/invite/InitiateEmailInvitation.vue',
    chunkName: 'marketing',
  },

  // 通讯录
  { path: 'dataMarketing/addressBook', component: 'dataMarketing/addressBook/index.vue', chunkName: 'marketing' },
  {
    path: 'dataMarketing/addressBook/selfAddedCustomersFrom',
    component: 'dataMarketing/addressBook/selfAddedCustomersFrom.vue',
    chunkName: 'marketing',
  },
  {
    path: 'dataMarketing/addressBook/selfAddedCustomersFrom/edit/:id',
    component: 'dataMarketing/addressBook/selfAddedCustomersFrom.vue',
    chunkName: 'marketing',
  },
  {
    path: 'dataMarketing/addressBook/groupManagement/add',
    component: 'dataMarketing/addressBook/groupManagementAddEditorFrom.vue',
    chunkName: 'marketing',
  },
  {
    path: 'dataMarketing/addressBook/groupManagement/detail/:id',
    component: 'dataMarketing/addressBook/groupDetail.vue',
    chunkName: 'marketing',
  },
  {
    path: 'dataMarketing/addressBook/groupManagement/edit/:id',
    component: 'dataMarketing/addressBook/groupManagementAddEditorFrom.vue',
    chunkName: 'marketing',
  },
]

// Add special routes (do not follow role prefix rules)
export const specialRoutes = [
  {
    path: '/errorPage/linkError',
    name: 'errorPage',
    component: () => import(/* webpackChunkName: "errorPage" */ '@/pages/errorPage/linkError.vue'),
  },
  {
    path: '/memberRefresh',
    name: 'memberRefresh',
    component: () => import(/* webpackChunkName: "memberRefresh" */ '@/pages/memberRefresh.vue'),
  },
]
